import qs from 'qs';
// import history from '../history_mobx.jsx';
import { history } from "../history_mobx";
import merge from 'lodash/merge';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

export default {
  getVars:(thisStr)=>{
    return qs.parse(thisStr?thisStr:window.location.search,{ ignoreQueryPrefix:true })
  },
  setVars:(newVars)=>{

    const newQuery=qs.stringify(newVars);
    const newLoc=`${window.location.pathname}${newQuery?`?${newQuery}`:''}`;
    if(newLoc!==`${window.location.pathname}${window.location.search}`) {
      //console.log('PUSH! 1',newLoc);
      history.push(newLoc);
    }
    return `?${newQuery}`;
  },
  appendVars:(newVars,returnStr=false)=>{
    let ob=qs.parse(window.location.search,{ ignoreQueryPrefix:true });
    ob=merge(ob,newVars);
    //ob=compact(ob);
    //ob=omitBy(ob,(item)=>{ if(item) { return true; } else { return false; }  })
    ob=pickBy(ob, identity);
    //console.log('omitBy',ob);
    let newQuery=qs.stringify(ob);

    console.log('PUSH! 2',`${window.location.pathname}${newQuery ? `?${newQuery}` : ''}`);
    if(returnStr) {
      return `${window.location.pathname}${newQuery ? `?${newQuery}` : ''}`
    } else {
      const newLoc=`${window.location.pathname}${newQuery ? `?${newQuery}` : ''}`;
      if(newLoc!==`${window.location.pathname}${window.location.search}`) {
        history.push(newLoc);
      }
      return `?${newQuery}`;
    }
  }
};
